export default "__VITE_ASSET__Ba9XUpy$__"